'use strict';

const flyout = require('./flyout'),
    ritualsStyles = require('./rituals-styles'),
    damHelper = require('./dam/dam-helper'),
    gtm = require('./modules/google').tagManager;

const GiftWrapping = function () {
    let resetOption = true;
    let clearGiftWrappingWhenClosed = false;
    const wrappingTypes = {
        NONE: 'none',
        TOGETHER: 'together',
        INDIVIDUAL: 'individual'
    };
    function init(updateGiftWrapAndGreetingCardBlockAndPrice) {
        $(document).on('change', '.js-giftwrap-checkbox', wrap);

        $(document).on('click', '#wrap-together', wrapTogether);

        $(document).on('click', '#wrap-individual', wrapIndividual);

        $(document).on('click', '.js-giftwrap-edit', function () {
            $('#wrap-individual').prop('checked', true);
            showDialog();
            resetOption = false;
        });

        $(document).on('click', '.js-remove-gift-wrapping', function (e) {
            e.preventDefault();
            e.stopPropagation();
            clearGiftWrapping();
        });

        function wrap() {
            const $this = $(this);
            if (!$this.prop('checked')) {
                clearGiftWrapping();
                return;
            }

            const $wrapIndividualCheckbox = $('#wrap-individual');
            if ($wrapIndividualCheckbox.length && $wrapIndividualCheckbox.prop('checked')) {
                $this.prop('checked', true);
                $('.js-giftwrap-options').addClass('enabled');
                resetOption = false;
                clearGiftWrappingWhenClosed = true;
                showDialog();
                return;
            }

            const $wrapTogetherCheckbox = $('#wrap-together');
            if ($wrapTogetherCheckbox.length && ($wrapTogetherCheckbox.prop('checked') || !$wrapTogetherCheckbox.prop('disabled'))) {
                wrapTogether(true);
                return;
            }
        }

        function clearGiftWrapping() {
            wrapProductsOrClearGiftWrapping(wrappingTypes.NONE);
        }

        function wrapTogether(override) {
            resetOption = true;
            if (override || this.checked) {
                $('.js-giftwrap-edit').hide();
                wrapProductsOrClearGiftWrapping(wrappingTypes.TOGETHER);
            }
        }

        function wrapIndividual() {
            resetOption = true;
            if (this.checked) {
                $('.js-giftwrap-edit').show();
                showDialog();

                initLazyLoad();
            }
        }

        function saveGiftWrapping() {
            resetOption = false;
            clearGiftWrappingWhenClosed = false;
            const $giftwrap = $('#giftwrap-container');
            const wrapInfo = $giftwrap.data('wrapinfo');

            const data = {
                'products': []
            };

            for (const prd in wrapInfo.products) {
                data.products.push({
                    'id': wrapInfo.products[prd].id,
                    'plid': wrapInfo.products[prd].plid,
                    'qty': $giftwrap.find('input[name=gift-wrapped-product][value=' + wrapInfo.products[prd].id + wrapInfo.products[prd].plid + ']:checked').length
                });
            }

            wrapProductsOrClearGiftWrapping(wrappingTypes.INDIVIDUAL, data, function() {
                flyout.closeFlyouts();
            });
        }

        function showDialog() {
            const isCheckoutV3 = $('.checkout-v3').length > 0;

            flyout.load({
                url: Urls.giftWrapShowProducts,
                open: function () {
                    const $giftwrap = $('#giftservice-products');
                    damHelper.updateImages($giftwrap);
                    const $saveBtn = $('.js-giftwrap-save');
                    const selectedItemsOnOpen = $giftwrap.find('input[name=gift-wrapped-product]:checked').length;

                    if (isCheckoutV3) {
                        $('.js-generic-flyout').addClass('checkout-v3');
                    }

                    $('.js-generic-flyout').addClass('giftwrap-flyout');

                    $('.js-giftwrap-cancel').on('click', function() {
                        flyout.closeFlyouts();
                    });

                    $saveBtn.on('click', saveGiftWrapping);

                    const checkAllCheckboxShouldBeChecked = $giftwrap.find('input[name=gift-wrapped-product]:checked').length
                        === $giftwrap.find('input[name=gift-wrapped-product]').length;
                    $('#checkall').prop('checked', checkAllCheckboxShouldBeChecked);

                    $giftwrap.on('change', $giftwrap.find('input[name=gift-wrapped-product]'), function() {
                        const checkAllCheckboxShouldBeChecked = $giftwrap.find('input[name=gift-wrapped-product]:checked').length
                            === $giftwrap.find('input[name=gift-wrapped-product]').length;
                        $('#checkall').prop('checked', checkAllCheckboxShouldBeChecked);

                        toggleSaveButton(selectedItemsOnOpen);
                    });

                    $('#checkall').on('change', function() {
                        $giftwrap.find('input[name=gift-wrapped-product]').prop('checked', !!this.checked);
                        toggleSaveButton(selectedItemsOnOpen);
                    });

                    const shouldDisableSaveBtn = $giftwrap.find('input[name=gift-wrapped-product]:checked').length === 0;
                    $saveBtn.prop('disabled', shouldDisableSaveBtn);

                    $('.js-generic-flyout ').find('.js-close-flyout').prependTo('#giftwrap-container .giftwrap-title');
                },
                close: function () {
                    if (resetOption && !$('#wrap-together').prop('disabled')) {
                        $('.js-giftwrap-edit').hide();
                        $('#wrap-together').prop('checked', true);
                    }

                    if (clearGiftWrappingWhenClosed) {
                        $('.js-giftwrap-checkbox').prop('checked', false);
                        $('.js-giftwrap-options').removeClass('enabled');
                        clearGiftWrappingWhenClosed = false;
                    }

                    setTimeout(function() {
                        if (isCheckoutV3) {
                            $('.js-generic-flyout').removeClass('checkout-v3');
                        }
                        $('.js-generic-flyout').removeClass('giftwrap-flyout');
                        $('#giftwrap-container .giftwrap-title').find('.js-close-flyout').prependTo('.js-generic-flyout');
                    }, 1000);
                }
            });
        }

        function toggleSaveButton(selectedItemsOnOpen) {
            const $giftwrap = $('#giftservice-products');
            const $saveBtn = $('.js-giftwrap-save');
            const shouldDisableSaveBtn = $giftwrap.find('input[name=gift-wrapped-product]:checked').length === 0
                && selectedItemsOnOpen === 0;
            $saveBtn.prop('disabled', shouldDisableSaveBtn);
        }
        function wrapProductsOrClearGiftWrapping(wrapType, giftwrapData, callback) {
            let data = 'wrapType=' + wrapType;
            if (giftwrapData && wrapType == wrappingTypes.INDIVIDUAL) {
                data += '&giftwrap_data=' + JSON.stringify(giftwrapData);
            }

            $.ajax({
                type: 'POST',
                url: Urls.wrapProductsOrClearGiftWrapping,
                data: data,
                success: function (data) {

                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    if (callback && $.isFunction(callback)) {
                        callback();
                    }

                    initLazyLoad();
                    pushDataLayerEvent();
                }
            });
        }

        function initLazyLoad() {
            if ($('.js-lazy-load').length) {
                ritualsStyles.initLazyLoad();
            }
        }
    }

    return {
        init: init
    };
};

function pushDataLayerEvent() {
    const $giftWrapDataLayerEl = $('.js-giftwrap-data-layer');
    if (!$giftWrapDataLayerEl || !$giftWrapDataLayerEl.length) {
        return;
    }

    const giftWrapLaterEvent = $giftWrapDataLayerEl.data('data-layer');
    if (!giftWrapLaterEvent) {
        return;
    }

    gtm.pushDataLayerEvent(JSON.parse(JSON.stringify(giftWrapLaterEvent)));
}

module.exports = new GiftWrapping();
